// Generated by ReScript, PLEASE EDIT WITH CARE


function toFloat(size) {
  if (size === "tiny") {
    return 11.0;
  } else if (size === "xtiny") {
    return 10.0;
  } else if (size === "xlarge") {
    return 17.0;
  } else if (size === "large") {
    return 16.0;
  } else if (size === "xxsmall") {
    return 12.0;
  } else if (size === "xsmall") {
    return 13.0;
  } else if (size === "small") {
    return 14.0;
  } else if (size === "normal") {
    return 15.0;
  } else {
    return 18.0;
  }
}

function toPx(size) {
  if (size === "tiny") {
    return "11px";
  } else if (size === "xtiny") {
    return "10px";
  } else if (size === "xlarge") {
    return "17px";
  } else if (size === "large") {
    return "16px";
  } else if (size === "xxsmall") {
    return "12px";
  } else if (size === "xsmall") {
    return "13px";
  } else if (size === "small") {
    return "14px";
  } else if (size === "normal") {
    return "15px";
  } else {
    return "18px";
  }
}

let xtiny = 10.0;

let tiny = 11.0;

let xxsmall = 12.0;

let xsmall = 13.0;

let small = 14.0;

let normal = 15.0;

let large = 16.0;

let xlarge = 17.0;

let huge = 18.0;

let xtinyPx = "10px";

let tinyPx = "11px";

let xxsmallPx = "12px";

let xsmallPx = "13px";

let smallPx = "14px";

let normalPx = "15px";

let largePx = "16px";

let xlargePx = "17px";

let hugePx = "18px";

export {
  xtiny,
  tiny,
  xxsmall,
  xsmall,
  small,
  normal,
  large,
  xlarge,
  huge,
  xtinyPx,
  tinyPx,
  xxsmallPx,
  xsmallPx,
  smallPx,
  normalPx,
  largePx,
  xlargePx,
  hugePx,
  toFloat,
  toPx,
}
/* No side effect */
